import React, { useCallback, useContext } from "react";
import { Button } from "@heroui/react";
import { useTranslation } from "react-i18next";
import { App } from "/app/src/models";
import NavigationMenuContext from "/app/src/contexts/NavigationMenuContext";
/**
 * Controls component for managing display controls.
 *
 * @param {Object} props - The properties object.
 * @param {App} props.app - The application object.
 * @param {function} props.toggleNew - Callback function to toggle the new display.
 * @param {boolean} props.activeNew - Boolean flag indicating if the new display is active.
 * @returns {JSX.Element} The rendered controls component.
 */
export default function Controls({
  app,
  toggleNew,
  activeNew,
}: {
  app: App;
  toggleNew: () => void;
  activeNew: boolean;
}) {
  const { t } = useTranslation();

  const navigationMenu = useContext(NavigationMenuContext);

  const toggleNewDisplay = useCallback(() => {
    toggleNew();
  }, [toggleNew]);

  return (
    <div className="wrapper">
      <div
        id="displays_app"
        className={`app controls mt-0 ${navigationMenu === "1" ? " -mx-[16px] mb-[25px]" : "-mx-[25px] mb-[25px]"}`}
      >
        <div className="icon"> </div>
        <div className="title">{app && <h1>{app.name}</h1>}</div>

        <div className="controlButtons">
          {activeNew ? (
            <Button
              color="primary"
              radius="none"
              variant="bordered"
              onPress={toggleNewDisplay}
              size="sm"
            >
              {t("translation:cancel")}
            </Button>
          ) : (
            <Button
              color="primary"
              radius="none"
              size="sm"
              onPress={toggleNewDisplay}
            >
              {t("translation:new_display")}
            </Button>
          )}
        </div>
      </div>
    </div>
  );
}
